import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { GeneralHeaderComponent } from './general-header/general-header.component';
import { MenuHeaderComponent } from './menu-header';
import { PricePipe, ProductDescriptionPipe } from './pipes';
import { SelectionButtonComponent } from './selection-button';
import { TileListComponent } from './tile-list/tile-list.component';
import { EndOfScrollComponent, InfiniteScrollComponent } from './infinite-scroll';
import { VisibilityService } from './infinite-scroll/services';

import { EllipsisModule } from 'ngx-ellipsis';
import { AddToCartModalComponent } from './add-to-cart-modal/add-to-cart-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HideHeaderDirective, SwipeDirective, ThrottleClickDirective } from './directives';
import { CustomerInfoFormComponent } from './forms/customer-info-form/customer-info-form.component';

@NgModule({
  imports: [CommonModule, IonicModule, EllipsisModule, FormsModule, ReactiveFormsModule],
  declarations: [
    MenuHeaderComponent,
    SelectionButtonComponent,
    TileListComponent,
    GeneralHeaderComponent,
    PricePipe,
    ProductDescriptionPipe,
    InfiniteScrollComponent,
    EndOfScrollComponent,
    AddToCartModalComponent,
    ThrottleClickDirective,
    SwipeDirective,
    HideHeaderDirective,
    CustomerInfoFormComponent,
  ],
  exports: [
    MenuHeaderComponent,
    SelectionButtonComponent,
    TileListComponent,
    GeneralHeaderComponent,
    PricePipe,
    ProductDescriptionPipe,
    InfiniteScrollComponent,
    AddToCartModalComponent,
    ThrottleClickDirective,
    SwipeDirective,
    HideHeaderDirective,
    CustomerInfoFormComponent,
  ],
  providers: [VisibilityService],
})
export class SharedComponentsModule {}
